import apiConfig from 'src/integration/config/apiConfig';
import useQueryKey from 'src/toolkit/utils/useQueryKey';
import { useStore } from 'src/integration/store/store';
import useReactQueryJava from 'src/integration/api/useReactQueryJava';
import { MIN_15 } from 'src/integration/config/constants';
import colors from 'src/integration/styles/colors';

interface FfrCapacityPriceDto {
  id: number;
  date: string;
  time: string;
  mfrrUpCapacityPrice: {
    value: number;
    unit: string;
  };
  mfrrDownCapacityPrice: {
    value: number;
    unit: string;
  };
  afrrUpCapacityPrice: {
    value: number;
    unit: string;
  };
  afrrDownCapacityPrice: {
    value: number;
    unit: string;
  };
  fcrPrice: {
    value: number;
    unit: string;
  };
}

const emptyChartData = {
  labels: [],
  datasets: [
    {
      label: 'mFRR up capacity price',
      data: [],
      backgroundColor: colors.chart.carminePink,
      borderRadius: 4,
      stack: 'mFRR',
    },
    {
      label: 'mFRR down capacity price',
      data: [],
      backgroundColor: colors.chart.carminePinkLight,
      borderRadius: 4,
      stack: 'mFRR',
    },
    {
      label: 'aFRR up capacity price',
      data: [],
      backgroundColor: colors.chart.pastelOrange,
      borderRadius: 4,
      stack: 'aFRR',
    },
    {
      label: 'aFRR down capacity price',
      data: [],
      backgroundColor: colors.chart.pastelOrangeLight,
      borderRadius: 4,
      stack: 'aFRR',
    },
    {
      label: 'FCR price',
      data: [],
      backgroundColor: colors.chart.oldMauve,
      borderRadius: 4,
    },
  ],
};

const useFetchFfrCapacityPrice = () => {
  const { settingsStore } = useStore();
  const { selectedSiteId, selectedDate } = settingsStore;

  const response = useReactQueryJava<FfrCapacityPriceDto[], SimpleObject>({
    endpoint: apiConfig.api.endpointsJava.ffrCapacityPrice,
    queryKey: useQueryKey('ffrCapacityPrice', [selectedDate, selectedSiteId?.toString()]),
    method: 'GET',
    queryParams: {
      date: selectedDate,
      siteId: selectedSiteId,
    },
    opts: {
      enabled: !!selectedSiteId,
      refetchOnWindowFocus: false,
      refetchInterval: MIN_15,
    },
  });

  const chartData = response?.data ? {
    labels: response.data.map((item) => item.time),
    datasets: [
      {
        ...emptyChartData.datasets[0],
        data: response.data.map((item) => item.mfrrUpCapacityPrice.value),
      },
      {
        ...emptyChartData.datasets[1],
        data: response.data.map((item) => item.mfrrDownCapacityPrice.value),
      },
      {
        ...emptyChartData.datasets[2],
        data: response.data.map((item) => item.afrrUpCapacityPrice.value),
      },
      {
        ...emptyChartData.datasets[3],
        data: response.data.map((item) => item.afrrDownCapacityPrice.value),
      },
      {
        ...emptyChartData.datasets[4],
        data: response.data.map((item) => item.fcrPrice.value),
      },
    ],
  } : emptyChartData;

  return {
    ...response,
    chartData,
  };
};

export default useFetchFfrCapacityPrice;